import {
  getNameDescriptionTableColumn,
  getTimeTableColumn,
  getCopyWithContentTableColumn,
  // getStatusTableColumn,
} from '@/utils/common/tableColumn'
import { cityMap } from '@/utils/utils'
import i18n from '@/locales'

export default {
  created () {
    this.columns = [
      getNameDescriptionTableColumn({
        field: 'name',
        title: i18n.t('scope.text_869'),
        edit: false,
        onManager: this.onManager,
        hideField: true,
        slotCallback: row => {
          return (
            <side-page-trigger onTrigger={() => this.handleOpenSidepage(row)}>{ row.name }</side-page-trigger>
          )
        },
      }),
      getCopyWithContentTableColumn({
        field: 'enterprise_name',
        title: i18n.t('scope.text_870'),
        minWidth: 150,
      }),
      {
        field: 'amount',
        title: i18n.t('scope.text_871'),
        minWidth: 120,
      },
      {
        field: 'address',
        title: i18n.t('scope.text_872'),
        minWidth: 110,
        formatter: ({ cellValue }) => {
          return cityMap(this.cities, cellValue)
        },
      },
      getCopyWithContentTableColumn({
        field: 'contact',
        title: i18n.t('scope.text_873'),
        minWidth: 110,
      }),
      getCopyWithContentTableColumn({
        field: 'department',
        title: i18n.t('scope.text_874'),
        minWidth: 130,
      }),
      getCopyWithContentTableColumn({
        field: 'position',
        title: i18n.t('scope.text_875'),
        minWidth: 110,
      }),
      getTimeTableColumn({ title: i18n.t('scope.text_876'), sortable: true }),
      {
        field: 'created_at',
        title: i18n.t('scope.text_888'),
        sortable: true,
        minWidth: 160,
        formatter: ({ cellValue }) => {
          return cellValue ? this.$moment(cellValue).add(3, 'M').format() : '-'
        },
      },
      // getStatusTableColumn({ title: '报备进度', statusModule: 'reportProject', minWidth: 100 }),
      {
        field: 'status',
        title: i18n.t('scope.text_877'),
        sortable: true,
        minWidth: 100,
        slots: {
          default: ({ row }) => {
            const status = {
              init: i18n.t('scope.text_889'),
              accept: i18n.t('scope.text_890'),
              refused: i18n.t('scope.text_891'),
              expired: i18n.t('scope.text_892'),
            }
            const statusClass = {
              init: 'status-info',
              accept: 'status-success',
              refused: 'status-danger',
              expired: 'status-danger',
            }
            if (row.status === 'refused') {
              return [
                <div class='text-truncate' class={ statusClass[row.status] }>{ status[row.status] }
                  <a-tooltip>
                    <template slot="title">
                      { row.memo }
                    </template>
                    <a-icon type="question-circle" class="ml-1" />
                  </a-tooltip>
                </div>,
              ]
            }
            return [
              <div class='text-truncate' class={ statusClass[row.status] }>{ status[row.status] }</div>,
            ]
          },
        },
      },
      // getCopyWithContentTableColumn({
      //   field: 'memo',
      //   title: '报备失败原因',
      //   minWidth: 110,
      // }),
    ]
  },
}
